import React from "react";
import PropTypes from "prop-types";
import { parseDate } from "@util/moment";
import { Card, Grid, DateTimeStandard } from "@curves/ui-base";
import { ReadTextField } from '@curves/ui-shared';
import { isEqual } from "@util/utils";
import { CLUB_SOURCE_TYPE } from "@clubInventory/constants/dataEnums";

// 功能：進貨單摘要資訊（顯示單號/建單日期/建單人/截止日/貨源/備註）
const PurchaseOrderSummaryCard = ({ className, purchaseReceipt, ...rest }) => {
	const { purchaseNo, purchaseDate, sourceType, sourceTypeText, sourceClubName, employeeName, inspectionDeadline, notes } = purchaseReceipt || {};

	const isClubTransfer = isEqual(sourceType, CLUB_SOURCE_TYPE.CLUBTRANSFER);

	const displayDate = value => parseDate(value, DateTimeStandard.DisplayDate);
	const emptyDisplay = "-";

	return (
		<Card className={className} {...rest}>
			<Card.CardContent className="p-3">
				<Grid container spacing={2}>
					<Grid xs={6} md={3} item>
						<ReadTextField label="進貨單編號">{purchaseNo || emptyDisplay}</ReadTextField>
					</Grid>
					<Grid xs={6} md={3} item>
						<ReadTextField label="建單日期">{displayDate(purchaseDate) || emptyDisplay}</ReadTextField>
					</Grid>
					<Grid xs={6} md={3} item>
						<ReadTextField label="建單人">{employeeName || emptyDisplay}</ReadTextField>
					</Grid>
					<Grid xs={6} md={3} item>
						<ReadTextField label="點收截止日" tip="若超過點收截止日，系統將自動完成入庫">
							{displayDate(inspectionDeadline) || emptyDisplay}
						</ReadTextField>
					</Grid>
					<Grid xs={6} md={3} item>
						<ReadTextField label="貨源" tip="總部或店鋪調撥">
							{sourceTypeText || emptyDisplay}
						</ReadTextField>
					</Grid>
					{isClubTransfer && (
						<Grid xs={6} md={3} item>
							<ReadTextField label="調撥店鋪">{sourceClubName || emptyDisplay}</ReadTextField>
						</Grid>
					)}

					<Grid xs={12} md={isClubTransfer ? 6 : 9} item>
						<ReadTextField label="訂單備註">{notes || emptyDisplay}</ReadTextField>
					</Grid>
				</Grid>
			</Card.CardContent>
		</Card>
	);
};

PurchaseOrderSummaryCard.propTypes = {
	className: PropTypes.string,
	purchaseReceipt: PropTypes.object,
};

export default PurchaseOrderSummaryCard;
